<template>
  <span
    translate="no"
    :class="['material-icons-round v-icon', { 'rtl-flip': rtlFlip }]"
    :style="{
      fontSize: size,
      color: color
    }"
  >
    {{ icon }}
  </span>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    size: { type: String, default: "" },
    outlined: { type: Boolean, default: false },
    color: { type: String, default: "" },
    rtlFlip: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss">
.v-icon {
  font-size: inherit;
}

[dir="rtl"] {
  .v-icon.rtl-flip {
    transform: rotate(180deg);
  }
}
</style>
